import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GlobalVariable } from '../global';

export interface ManualPageDto {
  pageNo: number;
  title: string;
  sortOrder: number;
}

@Injectable({
  providedIn: 'root'
})
export class ManualService {
  private readonly baseUrl = GlobalVariable.BASE_URL;

  constructor(private http: HttpClient) {}

  /**
   * ログインユーザーのロールに対応したマニュアルページ一覧を取得する
   * @param lang 言語コード ('jp' / 'en')
   */
  getManualPages(lang: string): Observable<ManualPageDto[]> {
    const langCode = lang?.toLowerCase() === 'en' ? 'EN' : 'JP';
    const params = new HttpParams().set('lang', langCode);

    return this.http
      .get<{ status: boolean; data: ManualPageDto[] }>(
        `${this.baseUrl}/manual/pages`,
        { params }
      )
      .pipe(map(res => res?.data ?? []));
  }
}
